// extracted by mini-css-extract-plugin
export default {"title":"unit_price_breakdown_title__mxIsy"};